import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useRemoveTrailingSlash() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // Check if pathname ends with a slash and is not just "/"
    if (pathname.length > 1 && pathname.endsWith("/")) {
      const newPathname = pathname.slice(0, -1);
      navigate(`${newPathname}${search}${hash}`, { replace: true });
    }
  }, [location, navigate]);
}
